module.exports = __webpack_public_path__ + "img/mifinity.12e8f3ae.svg";